module.exports = __webpack_public_path__ + "img/hardwareOpen7.46bcf762.png";